import request from '../utils/request';
import qs from "qs";

export const list = param => {
	return request.post('/api/company/list', qs.stringify(param))
};

export const addCompany = param => {
	return request.post('/api/company/add', qs.stringify(param))
};
//企业审核列表
export const companyAuditList = param => {
	return request.post('/api/company/companyAuditList', qs.stringify(param))
};

//企业审核
export const companyAudit = param => {
	return request.post('/api/company/companyAudit', qs.stringify(param))
};

export const updateCompany = param => {
	return request.post('/api/company/update', qs.stringify(param))
};
export const batchLocked = param => {
	return request.post('/api/company/batchLocked', qs.stringify(param))
};

export const delCompany = param => {
	return request.get('/api/company/delete?userId=' + param.userId + '&&id=' + param.id)
};

export const fetchCompanyById = companyId => {
	return request.get('/api/company/fetchCompanyById?companyId=' + companyId)
};

export const fetchCompanyByAgentId = param => {
	return request.get('/api/company/fetchCompanyByAgentId?agentId=' + param.agentId + '&&subAgent=' + param
		.subAgent)
};
//企业黑名单列表
export const companyBlacklist = param => {
	return request.get('/api/company/companyBlacklist?name=' + param.name + '&&pageIndex=' + param
		.pageIndex + '&&pageSize=' + param.pageSize)
};
//企业黑名单  添加
export const addCompanyBlacklist = param => {
	return request.post('/api/company/addCompanyBlacklist', qs.stringify(param))
};

//企业黑名单  删除
export const deleteBlackList = param => {
	return request.post('/api/company/deleteBlackList', qs.stringify(param))
};

// eslint-disable-next-line no-unused-vars
export const fetchDefaultCompanies = param => {
	return request.get('/api/company/fetchDefaultCompanies?currentUserId=' + param.currentUserId + '&&subAgentId=' +
		param.subAgentId)
};
// 企业类型
export const fetchCompanyType = res => {
	return request.get('/api/company/fetchCompanyType')
};
// 企业管理  激活数据
export const activateRecord = param => {
	return request.post('/api/companyLimit/activateRecord', qs.stringify(param))
};
// 企业管理  激活明细
export const activateInfo = param => {
	return request.post('/api/companyLimit/activateInfo', qs.stringify(param))
};
// 企业管理  激活明细数据导出
export const activateExport = param => {
	return request.post('/api/companyLimit/activateExport', qs.stringify(param), {
		responseType: 'blob'
	})
};
export const getQiNiuYunToken = agentId => {
	return request.get('/api/company/uploadToken')
};
//号码池列表
export const numberList = param => {
	return request.post('/api/numberPool/list', qs.stringify(param))
};

//号码池列表
export const companyLvLog = param => {
	return request.post('/api/company/companyLvLog', qs.stringify(param))
};

//号码池导入
export const numberPoolUpload = param => {
	return request.post('/api/numberPool/upload', qs.stringify(param))
};
//号码池删除
export const numberPoolDelete = param => {
	return request.post('/api/numberPool/delete', qs.stringify(param))
};
//查询省份
export const getProvince = param => {
	return request.post('/api/numberPool/getProvince', qs.stringify(param))
};
//查询市
export const getCity = param => {
	return request.post('/api/numberPool/getCity', qs.stringify(param))
};
//编辑
export const numberPoolEdit = param => {
	return request.post('/api/numberPool/update', qs.stringify(param))
};
//添加
export const addReportNumber = param => {
	return request.post('/api/blackList/addReportNumber', qs.stringify(param))
};
//手动添加
export const addReport = param => {
	return request.post('/api/blackList/addReport', qs.stringify(param))
};
//文件删除
export const numberPooldeleteFile = param => {
	return request.post('/api/numberPool/deleteUpload', qs.stringify(param))
};


//单个或者批量删除
export const snailsDeletes = param => {
	return request.post('/api/numberPool/snailsDelete', qs.stringify(param))
};

//单个或者批量删除
export const getSnailsList = param => {
	return request.post('/api/numberPool/snailsList', qs.stringify(param))
};

//修改是否合作
export const updateEnable = param => {
	return request.post('/api/company/updateEnable', qs.stringify(param))
};

//获取每个品牌坐席数
export const agentSeatCardType = param => {
	return request.post('/api/agent/agentSeatCardType', qs.stringify(param))
};

//获取领取记录
export const claimRecord = param => {
	return request.post('/api/intentionCustomer/claimRecord', qs.stringify(param))
};
//获取操作记录
export const crmUseRecord = param => {
	return request.post('/api/intentionCustomer/crmUseRecord', qs.stringify(param))
};
//查询部门数据设置
export const getDepartmentData = param => {
	return request.post('/api/intentionCustomer/getDepartmentData', qs.stringify(param))
};
//修改部门公海设置
export const setDepartmentData = param => {
	return request.post('/api/intentionCustomer/setDepartmentData', qs.stringify(param))

};
//设置领取数量
export const claimSetting = param => {
	return request.post('/api/intentionCustomer/claimSetting', qs.stringify(param))
};
//查询设置
export const setClaimSetting = companyId => {
	return request.get('/api/intentionCustomer/getClaimSetting?companyId=' + companyId)
};
//导出坐席数
export const getExportAgentSeat = param => {
	return request.post('/api/agent/ExportAgentSeat', qs.stringify(param), {
		responseType: 'blob'
	})
}; //导出
export const downloadCompany = param => {
	return request.post('/api/company/downloadCompany', qs.stringify(param), {
		responseType: 'blob'
	})
};
//列表
export const adminRoleList = param => {
	return request.get('/api/user/adminRoleList?userId=' + param.userId)
};
//启用停用账号
export const adminRoleStop = param => {
	return request.post('/api/user/adminRoleStop', qs.stringify(param))
};
//重置密码
export const adminRoleResetPwd = param => {
	return request.post('/api/user/adminRoleResetPwd', qs.stringify(param))
};
//添加
export const addAdminRole = param => {
	return request.post('/api/user/addAdminRole', qs.stringify(param))
};
//删除
export const adminRoleDelete = param => {
	return request.post('/api/user/adminRoleDelete', qs.stringify(param))
};
//企业在网信息
export const companyUseData = param => {
	return request.post('/api/company/companyUseData', qs.stringify(param))
};
//企业当前在网详情
export const companyUseInfo = param => {
	return request.post('/api/company/companyUseInfo', qs.stringify(param))
};
//企业当前在网导出
export const companyUseInfoDownload = param => {
	return request.post('/api/company/companyUseInfoDownload', qs.stringify(param), {
		responseType: 'blob'
	})
};
//在网数据导出
export const companyUseDataDownload = param => {
	return request.post('/api/company/companyUseDataDownload', qs.stringify(param), {
		responseType: 'blob'
	})
};
//企业规则设置
export const companyRulesSettingList = param => {
	return request.post('/api/companyRulesSetting/list', qs.stringify(param))
};
//批量设置企业共享黑名单
export const companyBatchSystemInterception = param => {
	return request.post('/api/company/batchSystemInterception', qs.stringify(param))
};
//手动评级
export const enterpriseManualRating = param => {
	return request.post('/api/companyRulesSetting/enterpriseManualRating', qs.stringify(param))
};
//企业等级规则  删除
export const deleteRules = param => {
	return request.post('/api/companyRulesSetting/delete', qs.stringify(param))
};
//企业等级规则 添加
export const addRules = param => {
	return request.post('/api/companyRulesSetting/addRules', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};
//企业等级规则 编辑
export const updateRules = param => {
	return request.post('/api/companyRulesSetting/update', param, {
		headers: {
			'Content-Type': 'application/json'
		}
	})
};